import { merchantInstance } from "@/axios-path.js";

// Auto Transfer: List transfer batches
export default {
    namespaced: true,
    state: {
        loading: false,
        error: null,
        list: [],
        count: 0,
        page: 1,
        page_size: 20,
    },
    mutations: {
        setLoading(state, v) {
            state.loading = !!v;
        },
        setError(state, e) {
            state.error = e || null;
        },
        setList(state, rows) {
            state.list = Array.isArray(rows) ? rows : [];
        },
        setMeta(state, { count, page, page_size }) {
            state.count = Number(count || 0);
            state.page = Number(page || 1);
            state.page_size = Number(page_size || 20);
        },
    },
    actions: {
        async fetch({ commit }, params = {}) {
            commit("setLoading", true);
            commit("setError", null);
            try {
                const query = {
                    page: params.page || 1,
                    page_size: params.page_size || 20,
                    province_id: params.province_id || undefined,
                    district_id: params.district_id || undefined,
                    is_cancelled: params.is_cancelled,
                    order: params.order || "created",
                };
                const res = await merchantInstance.get(
                    "/api/v1/merChant/AutoTransfer/ListBatches",
                    {
                        params: query,
                        headers: { "X-App-Client": "weserve_backoffice" },
                    }
                );
                let payload = null;
                if (res && res.msg && res.data) payload = res;
                else if (res && res.data) payload = { ...res, msg: true };
                else if (Array.isArray(res)) payload = { msg: true, data: res, count: res.length, page: query.page, page_size: query.page_size };
                else payload = res;

                const rows = (payload && payload.data) || [];
                commit("setList", rows);
                commit("setMeta", {
                    count: payload && payload.count,
                    page: payload && payload.page,
                    page_size: payload && payload.page_size,
                });
                return rows;
            } catch (e) {
                commit("setError", e);
                commit("setList", []);
                commit("setMeta", { count: 0, page: 1, page_size: 20 });
                return [];
            } finally {
                commit("setLoading", false);
            }
        },

        async fetchTransferItemById({ commit }, payload = {}) {
            commit("setError", null);
            try {
                const itemId = Number(payload.item_id || payload.itemId);
                const res = await merchantInstance.get(
                    "/api/v1/merChant/financial/transfer-item",
                    {
                        params: { item_id: itemId },
                        headers: { "X-App-Client": "weserve_backoffice" },
                    }
                );

                const data = res && res.data ? res.data : res;
                if (data && data.msg && data.data) return data.data;
                if (data && data.data) return data.data;
                return data;
            } catch (e) {
                commit("setError", e);
                return null;
            }
        },

        async updateStatus({ commit }, payload = {}) {
            commit("setError", null);
            try {
                const body = {
                    batch_id: payload.batch_id,
                    record_status: payload.record_status,
                };
                const res = await merchantInstance.post(
                    "/api/v1/merChant/AutoTransfer/UpdateBatchStatus",
                    body,
                    {
                        headers: { "X-App-Client": "weserve_backoffice" },
                    }
                );

                if (res && res.msg && res.data) return res.data;
                if (res && res.data && res.data.data) return res.data.data;
                if (res && res.data) return res.data;
                return res;
            } catch (e) {
                commit("setError", e);
                return null;
            }
        },
    },
    getters: {
        list: (s) => s.list,
        loading: (s) => s.loading,
        error: (s) => s.error,
        count: (s) => s.count,
        page: (s) => s.page,
        page_size: (s) => s.page_size,
    },
};
